import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { FormModalComponent } from './form-modal.component';

import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: '',
        component: FormModalComponent
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        TranslateModule
    ],
    declarations: [FormModalComponent]
})
export class FormModalModule { }
